const STORAGE_PREFIX = 'x-verdict:tenant-verification-services';
const PROJECT_SESSION_KEYS = [
  'project_id',
  'selected_project_id',
  'current_project_id',
  'active_project_id',
];

function positive_number(value) {
  const number = Number(value || 0);
  return Number.isFinite(number) && number > 0 ? number : null;
}

function current_project_id(project_id = null) {
  const explicit_id = positive_number(project_id);
  if (explicit_id) return explicit_id;
  if (typeof window === 'undefined') return null;

  return PROJECT_SESSION_KEYS
    .map((key) => positive_number(window.sessionStorage.getItem(key)))
    .find(Boolean) || null;
}

function storage_key(project_id = null) {
  return `${STORAGE_PREFIX}:${current_project_id(project_id) || 'default'}`;
}

export function selectedTenantVerificationServiceIds(project_id = null) {
  if (typeof window === 'undefined') return [];
  try {
    const values = JSON.parse(window.localStorage.getItem(storage_key(project_id)) || '[]');
    return Array.isArray(values) ? [...new Set(values.map(positive_number).filter(Boolean))] : [];
  } catch {
    return [];
  }
}

export function saveTenantVerificationServiceIds(service_ids = [], project_id = null) {
  const normalized_ids = [...new Set((Array.isArray(service_ids) ? service_ids : [])
    .map(positive_number)
    .filter(Boolean))];
  if (typeof window !== 'undefined') {
    window.localStorage.setItem(storage_key(project_id), JSON.stringify(normalized_ids));
  }
  return normalized_ids;
}
